// src/components/business/BusinessSettingsPanel.tsx
//
// DEM-2121 F5 — a aba "Configurações" do business agora tem SUB-ABAS:
//   • Geral    → conteúdo atual (BusinessSettingsTab), preservado sem mudança.
//   • Domínios → NOVA (BusinessDomainsTab): N domínios verificáveis via DNS TXT.
//
// Este wrapper só orquestra a troca de sub-aba; a lógica de cada uma mora no
// seu componente. Mantém o padrão visual .wf-biztabs (mesmo das abas de topo).

import { useState } from 'react';
import type { Business, BusinessDNA } from '@/lib/api';
import { BusinessSettingsTab } from './BusinessSettingsTab';
import { BusinessDomainsTab } from './BusinessDomainsTab';

type SubTab = 'geral' | 'domains';

const SUBTAB_ITEMS: { value: SubTab; label: string }[] = [
  { value: 'geral', label: 'Geral' },
  { value: 'domains', label: 'Domínios' },
];

interface BusinessSettingsPanelProps {
  business: Business;
  dna: BusinessDNA | null;
  onBusinessUpdated: (biz: Business) => void;
  onDnaUpdated: (dna: BusinessDNA) => void;
}

export function BusinessSettingsPanel({
  business,
  dna,
  onBusinessUpdated,
  onDnaUpdated,
}: BusinessSettingsPanelProps) {
  const [subTab, setSubTab] = useState<SubTab>('geral');

  return (
    <div>
      {/* Sub-abas (mesmo visual .wf-biztabs das abas de topo) */}
      <div className="wf-biztabs" role="tablist" aria-label="Sub-abas de configurações" style={{ marginBottom: 12 }}>
        {SUBTAB_ITEMS.map((t) => (
          <button
            key={t.value}
            type="button"
            role="tab"
            aria-selected={subTab === t.value}
            className={subTab === t.value ? 'active' : undefined}
            onClick={() => setSubTab(t.value)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {subTab === 'geral' && (
        <BusinessSettingsTab
          business={business}
          dna={dna}
          onBusinessUpdated={onBusinessUpdated}
          onDnaUpdated={onDnaUpdated}
        />
      )}

      {subTab === 'domains' && <BusinessDomainsTab businessId={business.id} />}
    </div>
  );
}
